export default __webpack_public_path__ + "static/media/flagFrance.aeffa245.svg";